import { Component } from '@angular/core';

@Component({
  selector: 'itl-wizard-page-footer',
  template: '<ng-content> </ng-content>',
  standalone: false,
})
export class WizardPageFooterComponent {}
